import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import EffectAverageMeter from './EffectAverageMeter/EffectAverageMeter';
import { ResultTableTitle } from './ReportEffectResults.styles';
import ResultsViewToggle, { ResultsViewMode } from './ResultsViewToggle/ResultsViewToggle';
import { useReportContext } from '../../../../hooks/useReport';
import { Analysis } from '../../../../services/reports';
import EffectReportTemplate from '../../SharedEffectReportComponents/EffectReportTemplate/EffectReportTemplate';

const ReportEffectResults = () => {
  const {
    effectData,
    structuredEffectData: { results },
  } = useReportContext();
  const { t } = useTranslation();
  const [viewMode, setViewMode] = useState<ResultsViewMode>('categorized');

  const order = ['EFFECT INPUT', 'EFFECT PROCESSES', 'EFFECT EMERGENT STATES', 'EFFECT OUTPUT'];

  const sortedResults = Object.values(results).sort((a, b) => {
    return order.indexOf(a.type) - order.indexOf(b.type);
  });

  const allTopicsResult: Analysis = useMemo(() => {
    const allCodes = sortedResults.flatMap(item => item.included_topics);
    const sortedByScore = [...allCodes].sort((codeA, codeB) => {
      const topicA = effectData?.topics.find(t => t.code === codeA);
      const topicB = effectData?.topics.find(t => t.code === codeB);
      return (topicA?.average_value ?? 0) - (topicB?.average_value ?? 0);
    });
    return {
      type: 'EFFECT ALL TOPICS',
      description: t('report.effect.topics.allTopicsDescription'),
      included_topics: sortedByScore,
    };
  }, [sortedResults, effectData, t]);

  return (
    <ResultTableTitle>
      {effectData?.average ? <EffectAverageMeter average={effectData.average} /> : null}
      <ResultsViewToggle viewMode={viewMode} onChange={setViewMode} />
      {viewMode === 'all' ? (
        <EffectReportTemplate data={allTopicsResult} />
      ) : (
        sortedResults.map(item => <EffectReportTemplate key={item.type} data={item} />)
      )}
    </ResultTableTitle>
  );
};

export default ReportEffectResults;
